<!-- 出差数据操作 -->
<template>
   <div>
      <div v-if="isLoaded">
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
               <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val)=>{showTabs=val}" @tabHeight="(val)=>{mxHeight=val}">
                  <template slot="tabs" slot-scope="scope">
                     <div class="table_content_box">
                        <!-- 主要信息 -->
                        <div v-if="scope.index == 0">
                           <el-form label-width="100px" class="baseForm" :model="sendDataInfo" id="mainInfo" ref="sendDataInfo" size="mini" :show-message="false">
                              <el-row ref="mainForm" v-if="dataActionBox.actionType != 2">
                                 <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow==1" v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey" :prop="formOneValue.entityField"
                                               :rules="formOneValue.isRequired == 1 ? [{required: true,  trigger: ['blur', 'change']}] : []">
                                    <!-- 申请人	 -->
                                    <el-tooltip v-if="formOneValue.fieldType == 'search'" class="item"
                                                :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9"
                                                effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                       <el-input clearable @clear="clearClick(formOneValue.setField)" :ref="formOneValue.entityField"
                                                 @keyup.enter.native="openSearch(formOneValue.searchId,formOneValue.isIndex, formOneValue.entityField,formOneValue.setField)"
                                                 :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength">
                                          <el-button @click="openSearch(formOneValue.searchId,formOneValue.isIndex, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"></el-button>
                                       </el-input>
                                    </el-tooltip>
                                    <el-select v-else-if="formOneValue.entityField == 'course'" v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                       <el-option label="应付" value="pay" v-if="sendDataInfo.unitType==1"></el-option>
                                       <el-option label="预付" value="prepay" v-if="sendDataInfo.unitType==1"></el-option>
                                       <el-option label="应收" value="rece" v-if="sendDataInfo.unitType==2"></el-option>
                                       <el-option label="预收" value="prerece" v-if="sendDataInfo.unitType==2"></el-option>
                                    </el-select>
                                    <el-select clearable size="mini" filterable v-else-if="formOneValue.fieldType == 'formatter'"
                                                  v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                          <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)" :key="matItem.key" :label="matItem.key" :value="matItem.value"></el-option>
                                       </el-select>
                                    <el-input :ref="formOneValue.entityField" type="number" v-else-if="formOneValue.entityField == 'takeAmount'" clearable
                                              :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" v-model.trim="sendDataInfo[formOneValue.entityField]"
                                              @keyup.enter.native="nextFocus(formOneValue.isIndex)"></el-input>
                                    <el-input v-else :ref="formOneValue.entityField" clearable :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" v-model.trim="sendDataInfo[formOneValue.entityField]"
                                              :maxlength="$store.state.inputLength" @keyup.enter.native="nextFocus(formOneValue.isIndex)"></el-input>
                                 </el-form-item>
                              </el-row>
                              <el-row ref="mainForm" v-if="dataActionBox.actionType == 2">
                                 <el-form-item :label="formOneValue.showField+':'" v-if="formOneValue.isShow==1" v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                                               :prop="formOneValue.entityField" :rules="formOneValue.isRequired == 1 ? [{required: true,  trigger: ['blur', 'change']}] : []">
                                    <span v-if="formOneValue.isRift == 1">
                                       <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{sendDataInfo[formOneValue.entityField]}}</a>
                                    </span>
                                    <span v-else-if="formOneValue.entityField == 'purmSdate'&&sendDataInfo[formOneValue.entityField]">{{$common.getLocalTime(sendDataInfo[formOneValue.entityField])}}</span>
                                    <span v-else>{{sendDataInfo[formOneValue.entityField]}}</span>
                                 </el-form-item>
                              </el-row>
                           </el-form>
                        </div>
                     </div>
                  </template>
               </v-tabs>
            </el-card>

            <div class="foots">
               <el-button v-if="dataActionBox.actionType!=2" type="primary" @click="initActionBox('sendDataInfo')">取消</el-button>
               <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType==0">保存</el-button>
               <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType==1">保存</el-button>
            </div>

         </div>
      </div>

      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
         <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" :parentSearchData="parentSearchData" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
   name: "unitReconionAction",
   props: ["actionData"],
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
   },
   data() {
      //这里存放数据
      return {
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "新增" || "编辑",
            actionType: 0, // 0新增，1修改
         },
         detaislDataInfo: {},
         selectedDataIndex: 0,
         sendDataInfo: {},
         showTabs: "",
         formDataList: [],
         tabForm: [],
         mxForm: [],
         defaultDetail: {},
         footForm: [],
         DialogVisible: false, //检索
         seId: "",
         seWidth: "",
         seTitle: "",
         seType: "",
         sField: "",
         isLoaded: false,
         parentSearchData: {},
         inputel: [],
         seIndex: 0,
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {},
   //方法集合
   methods: {
      clearClick(setField) {
         let arr = setField.split(",");
         arr.forEach((item) => {
            this.sendDataInfo[item] = ""
         });
      },
      toDetail(orderId) {
         this.$parent.$parent.$parent.toDetail(orderId);
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, sField) {
         this.parentSearchData = {}
         this.DialogVisible = true;
         this.seIndex = index
         this.seId = sId;
         this.seType = type;
         this.sField = sField
         if (this.seType == 'salesName') {
            if (this.sendDataInfo.unitId=="") {
                return this.$message.error("请先选择单位！")
            }
            this.$set(this.parentSearchData, 'unitId', this.sendDataInfo.unitId)
         }
         this.$set(this.parentSearchData, type, this.sendDataInfo[type])
      },
      //提取返回
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            if (this.seType == 'unitName') {
               this.$set(this.sendDataInfo, 'unitType', val.unitType)
               this.$set(this.sendDataInfo, 'course', "")
            }
            this.paramValue(val)
            this.DialogVisible = false;
         }
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(",");
         arr.forEach((item) => {
            this.sendDataInfo[item] = val[item];
         });
         this.$nextTick(() => {
            this.nextFocus(this.seIndex);
         });
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },
      //确认新增
      sendDataAction(formName1) {
         this.$refs[formName1].validate((valid) => {
            if (valid) {
               // console.log(this.sendDataInfo)
               this.sub();
            } else {
               this.$message({
                  message: "请完善必填信息",
                  type: "error",
               });
               return false;
            }
         });
      },
      async sub() {
         var responseData;
         if (this.dataActionBox.actionType == 0) {
            responseData = await this.$http.addUnitRecon(this.sendDataInfo);
         } else {
            responseData = await this.$http.travelUpdate(this.sendDataInfo);
         }
         if (responseData.status == 200) {
            this.init();
            this.$message({
               message: "操作成功",
               type: "success",
            });
            this.$emit("drawerCancel", 1);
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },

      //取消
      initActionBox(sendDataInfo) {
         this.$emit("drawerCancel");
         this.init();
         this.$refs[sendDataInfo].resetFields();
      },
      //初始化
      init() {
         for (let key in this.sendDataInfo) {
            if (key == "takeAmount") {
               this.sendDataInfo[key] = 0
            } else {
               this.sendDataInfo[key] = "";
            }
         }
      },
      //父级传入
      openBox(cate, formData, oldData = "") {
         this.showTabs = formData[0].jciName;
         this.formDataList = formData;
         this.filterMainField();
         if (cate == 0) {
            this.dataActionBox.boxTitle = "新增信息";
            this.dataActionBox.openMode = "ltr";
         } else if (cate == 1) {
            this.dataActionBox.boxTitle = "编辑信息";
            this.dataActionBox.openMode = "rtl";
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.sendDataInfo[key] = dataInfo[key];
            }
         } else {
            this.dataActionBox.boxTitle = "查看信息";
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.sendDataInfo[key] = dataInfo[key];
            }
         }
         this.dataActionBox.actionType = cate;
         this.dataActionBox.showStatus = true;
         this.$nextTick(() => {
            setTimeout(() => {
               this.getMainInput()
               this.initFocus();
            }, 100)
         });
      },
      // 过滤表单不同类型
      filterMainField() {
         var mainFormList = [];
         this.formDataList.forEach((item) => {
            if (item.jciType == 1) {
               mainFormList.push(item);
            } else if (item.jciType == 2) {
               this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform));
               this.mxForm.forEach(item1 => {
                  if (item1.fieldType == 'number') {
                     this.$set(this.defaultDetail, item1.entityField, 0)
                  } else if (item1.fieldType == 'search' && item1.setField) {
                     var arr = item1.setField.split(',')
                     arr.forEach(item2 => {
                        this.$set(this.defaultDetail, item2, "")
                     })
                  } else {
                     this.$set(this.defaultDetail, item1.entityField, "")
                  }
               })


            } else if (item.jciType == 3) {
               this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
            }
         });
         mainFormList.forEach((key, i) => {
            this.tabForm[i] = JSON.parse(JSON.stringify(key));
            this.tabForm[i].jurconfigform = [];
            var index1 = 0
            for (let index = 0; index < key.jurconfigform.length; index++) {
               // if (key.jurconfigform[index].isShow == 1)
               if (key.jurconfigform[index].isShow == 1) {
                  key.jurconfigform[index].isIndex = index1
                  index1++
               }
               this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);

            }
         });
         var obj = this.$common.filterMainFields(this.formDataList, [], mainFormList[0])
         console.log(obj);

         for (let key in obj) {
            this.$set(this.sendDataInfo, key, obj[key])
         }
      },
      // 获取主表单所有input
      getMainInput() {
         var el = document.getElementById("mainInfo");
         if (el) this.inputel = el.getElementsByTagName("input");
      },
      // 初始化焦点
      initFocus() {
         for (let index = 0; index < this.inputel.length; index++) {
            if (this.inputel[index].value == "") {
               this.inputel[index].focus();
               break;
            }
         }
      },
      // 输入框切换焦点
      nextFocus(index) {
         if (index >= this.inputel.length - 1) {
            return;
         }
         var aindex = index + 1;
         if (
            this.inputel[aindex].value != "" ||
            this.inputel[aindex].disabled
         ) {
            this.nextFocus(aindex);
            return;
         }
         this.inputel[aindex].focus();
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.$nextTick(() => {
         var params = this.actionData;
         this.openBox(params.cate, params.formData, params.oldData);
         this.isLoaded = true;
      });
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { this.getMainInput() }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

.table_content_box {
   overflow-y: auto;
}

.el-row {
   display: flex;
   flex-wrap: wrap;
   padding-right: 20px;
}

.el-drawer {
   outline: none;
}
</style>
